<template>
  <vue-final-modal v-model="showModal" @closed="modalClosed" classes="modal-container" content-class="modal-content" focus-trap esc-to-close>
    <div class="modal__close">
      <button @click="showModal = false">
        <mdi-close></mdi-close>
      </button>
    </div>
    <h2 class="modal__title" :class="{ hidden: !titleStatus }">{{ content.title }}</h2>
    <div class="modal__content" v-bind:class="contentOrder">
      <div class="modal__image u-mb-4" v-if="content.image_url">
        <img v-bind:src="content.image_url" v-bind:alt="content.image_alt">
      </div>
      <div class="modal__body rich-text" v-if="content.body" v-html="content.body"></div>
    </div>

    <div class="modal__button-container">
      <a class="modal__btn btn" v-for="(button, index) in content.buttons" v-bind:key="index" v-bind:href="button.url" v-bind:class="{'btn--solid' : index === 0}">
        {{ button.text }}
      </a>
    </div>
  </vue-final-modal>
</template>

<script>
import axios from 'axios';
import { VueFinalModal } from 'vue-final-modal'
var VueCookie = require('vue-cookie');
import MdiClose from './components/MdiClose.vue';

export default {
  name: 'App',
  components: {
    VueFinalModal,
    MdiClose,
  },
  data: () => ({
    mainDomain: '',
    showModal: false,
    titleStatus: false,
    displayOrder: 'image_body_button',
    ccmDateUpdated: '',
    content: {},
  }),
  computed: {
    contentOrder() {
      return this.displayOrder === 'body_image_button' ? 'order-reverse' : '';
    }
  },
  beforeMount() {
    if (!document.getElementById('splash-id')) {
      return
    }
    // Get main domain from the splash id element (this is provided by nginx).
    let domain = document.getElementById('splash-id').innerHTML;

    // If last character isn't a forward slash, add one.
    if (domain.slice(-1) !== '/') {
      this.mainDomain = domain + '/';
    } else {
      this.mainDomain = domain;
    }
  },
  mounted () {
    axios
      .get(this.mainDomain + 'jsonapi/config_pages/crisis_communication_modal?include=field_cp_ccm_image.field_media_image&fields[file--file]=uri,url')
      .then(response => {
        if (!response.data.data[0]) {
          return;
        }
        const data = response.data.data[0].attributes;
        this.ccmDateUpdated = data.changed;

        // If config page has not been updated (user has already seen modal), stop.
        // Otherwise, delete ccm cookie so existing one can be created.
        if (data.changed === VueCookie.get('crisis_communication_modal')) {
          return;
        } else {
          VueCookie.delete('crisis_communication_modal');
        }

        let isLgov = document.body.dataset.ccmStatus;

        // If the modal is enabled.
        if (data.field_cp_ccm_enabled) {

          // If on lgov but not on a matched path, stop.
          if (isLgov && isLgov === '0') {
            return;
          }

          // If not on lgov and estate wide splash screen is not enabled, stop.
          if (!isLgov && !data.field_cp_ccm_estate_wide_s_s) {
            return;
          }

          let imageUrl = '';
          let imageAlt = '';
          // Get image url from includes if the image field has data.
          if (response.data.data[0].relationships.field_cp_ccm_image.data) {
            response.data.included.forEach(include => {
              if (include.type === 'file--file') {
                imageUrl = include.links.media_component_16_9_f_lg.href;
              }
              if (include.type === 'media--image') {
                imageAlt = include.relationships.field_media_image.data.meta.alt;
              }
            })
          }

          const buttons = [];
          // Create buttons array.
          if (data.field_cp_ccm_button) {
            data.field_cp_ccm_button.forEach(button => {
              buttons.push({
                url: button.url,
                text: button.title
              })
            })
          }

          // Add values into data.
          this.titleStatus = data.field_cp_ccm_show_title;
          this.displayOrder = data.field_cp_ccm_display_order;
          this.content = {
            ...this.content,
            title: data.field_cp_ccm_title,
            body: data.field_cp_ccm_body ? data.field_cp_ccm_body.value : '',
            buttons: buttons,
            image_url: imageUrl ? imageUrl : '',
            image_alt: imageAlt ? imageAlt : '',
          }

          // Show modal.
          this.showModal = true
        }
      })
  },
  methods: {
    modalClosed() {
      VueCookie.set('crisis_communication_modal', this.ccmDateUpdated, 365);
    }
  }
}
</script>

<style scoped>
:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep(.modal-content) {
  position: relative;
  padding: 2rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  width: 90%;
  font-family: Arial,Helvetica,sans-serif;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
.modal-content > * + * {
  margin-top: 25px;
}
.modal__title {
  font-size: 2.5rem;
  line-height: 2.5rem;
  letter-spacing: 0.01563rem;
  margin-bottom: 0;
  font-weight: 700;
}
.modal__title.hidden {
  display: none;
}
.modal__close {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.modal__close button {
  width: 40px;
  padding: 0;
  background-color: transparent;
  border: none;
}
.modal__close button:hover {
  cursor: pointer;
}
.modal__content {
  display: flex;
  flex-direction: column;
}
.modal__content.order-reverse {
  flex-direction: column-reverse;
}
.modal__content.order-reverse .modal__body {
  margin-bottom: 25px;
}
.modal__content .modal__image {
  margin-bottom: 25px;
}
.modal__content.order-reverse .modal__image {
  margin-bottom: 0;
}
.modal__image img {
  width: 100%;
}
.modal__button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.modal__btn {
  display: inline-block;
  padding: 14px 24px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  text-align: center;
  letter-spacing: -0.015rem;
  border: 2px solid #e7135d;
  border-radius: 6px;
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  color: #333;
  text-decoration: none;
  margin: 0.5rem 0 0 0.5rem;
}

.modal__btn:hover {
  color: #fff;
  background-color: #e7135d;
}
.modal__btn.btn--solid {
  color: #fff;
  border-color: #e7135d;
  background-color: #e7135d;
}
.modal__btn.btn--solid:hover {
  text-decoration: underline;
  text-decoration-thickness: 0.125rem;
  -webkit-text-decoration-style: solid;
  text-decoration-style: solid;
  text-underline-offset: 0.1875rem;
}
@media screen and (min-width: 576px) {
  :deep(.modal-content) {
    width: 70%;
  }
}
@media screen and (min-width: 768px) {
  :deep(.modal-content) {
    width: 50%;
  }
}
@media screen and (min-width: 992px) {
  :deep(.modal-content) {
    width: 40%;
  }
}
@media screen and (min-width: 1920px) {
  :deep(.modal-content) {
    width: 25%;
  }
}

:deep(ol),
:deep(ul) {
  list-style: none;
  margin: 0;
  padding: 0;
}
.rich-text {
  max-width: 73ch;
}
:deep(.rich-text strong) {
  font-weight: 700;
}
:deep(.rich-text ol) {
  --list-counter-style: decimal;
}
:deep(.rich-text ol > li) {
  position: relative;
  padding-left: 1.75em;
}
:deep(.rich-text ul > li) {
  position: relative;
  padding-left: 1.75em;
}
:deep(.rich-text ol > li::before) {
  position: absolute;
  left: 0;
  content: counter(list-item,decimal) ".";
  content: counter(list-item,var(--list-counter-style, decimal)) ".";
  color: #9e0059;
  font-weight: 400;
}
:deep(.rich-text ul > li::before) {
  position: absolute;
  top: calc(0.875em - 0.1875em);
  left: 0.25em;
  width: 0.375em;
  height: 0.375em;
  content: "";
  border-radius: 50%;
  background-color: #9e0059;
}
:deep(.rich-text hr) {
  margin-top: 2rem;
  margin-bottom: 2rem;
  border-color: #e6e6e6;
  border-top-width: 1px;
}
:deep(.rich-text h3) {
  margin-top: 5rem;
  margin-bottom: 1.5rem;
}
:deep(.rich-text h4) {
  margin-top: 4rem;
  margin-bottom: 1.5rem;
}
:deep(.rich-text h5) {
  margin-top: 4rem;
  margin-bottom: 1.5rem;
}
:deep(.rich-text h6) {
  margin-top: 3rem;
  margin-bottom: 1.5rem;
}
:deep(.rich-text figure figcaption) {
  margin-top: 0.75rem;
  color: #333;
  font-size: 16px;
  line-height: 19px;
}
:deep(.rich-text code) {
  font-size: 0.8888888889em;
}
:deep(.rich-text p) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
:deep(.rich-text--condensed-line-height p) {
  margin-top: 0.25em;
  margin-bottom: 0.25em;
}
:deep(.rich-text img),
:deep(.rich-text video),
:deep(.rich-text figure) {
  margin-top: 2em;
  margin-bottom: 2em;
}
:deep(.rich-text .scrollable-table),
:deep(.rich-text > table) {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
:deep(.rich-text figure > *) {
  margin-top: 0;
  margin-bottom: 0;
}
:deep(.rich-text ol),
:deep(.rich-text ul) {
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}
:deep(.rich-text li) {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
:deep(.rich-text > ul > li p) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
:deep(.rich-text > ul > li > *:first-child) {
  margin-top: 1.25em;
}
:deep(.rich-text > ul > li > *:last-child) {
  margin-bottom: 1.25em;
}
:deep(.rich-text > ol > li > *:first-child) {
  margin-top: 1.25em;
}
:deep(.rich-text > ol > li > *:last-child) {
  margin-bottom: 1.25em;
}
:deep(.rich-text ul ul),
:deep(.rich-text ul ol),
:deep(.rich-text ol ul),
:deep(.rich-text ol ol) {
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}
:deep(.rich-text hr + *),
:deep(.rich-text h3 + *),
:deep(.rich-text h4 + *),
:deep(.rich-text h5 + *),
:deep(.rich-text h6 + *) {
  margin-top: 0;
}
:deep(.rich-text > :first-child) {
  margin-top: 0;
}
:deep(.rich-text > :last-child) {
  margin-bottom: 0;
}

@media screen and (min-width: 1200px) {
  :deep(.rich-text) {
    font-size: 20px;
    line-height: 30px;
  }

  :deep(.rich-text hr) {
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }
}
</style>

<style scoped>
.dark-mode div::deep(.modal-content) {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
